<div class="dialog-header header-simple">
  <h2 mat-dialog-title>
    {{ 'createDoc.createDocDialog.title' | transloco }}
  </h2>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form">
  <mat-dialog-content>
    <section class="section">
      <label class="field-label">
        {{ 'createDoc.createDocDialog.producerLabel' | transloco }}
        <span class="required">*</span>
      </label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="manufacturerId">
          <mat-option *ngFor="let c of manufacturers" [value]="c.companyProfileId">
            {{ c.companyName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        <span>{{ 'createDoc.createDocDialog.producerHint' | transloco }}</span>
      </div>
      <div *ngIf="selectedManufacturer" class="company-card">
        <div class="company-icon">
          <mat-icon>apartment</mat-icon>
        </div>
        <div class="company-details">
          <div class="company-name">{{ selectedManufacturer.companyName }}</div>
          <div>
            {{ selectedManufacturer.address }},
            {{ selectedManufacturer.postCode }}
            {{ selectedManufacturer.city }},
            {{ selectedManufacturer.location }}
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <div>
          <h3 class="section-title">
            {{ 'createDoc.createDocDialog.representativeTitle' | transloco }}
          </h3>
          <p class="section-subtitle">
            {{ 'createDoc.createDocDialog.representativeSubtitle' | transloco }}
          </p>
        </div>
        <mat-slide-toggle formControlName="hasRepresentative" color="primary">
        </mat-slide-toggle>
      </div>
      <ng-container *ngIf="form.value.hasRepresentative">
        <label class="field-label">
          {{ 'createDoc.createDocDialog.representativeLabel' | transloco }}
        </label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select formControlName="representativeId">
            <mat-option *ngFor="let c of representatives" [value]="c.companyProfileId">
              {{ c.companyName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="info-hint">
          <mat-icon color="primary" inline>info</mat-icon>
          <span>{{ 'createDoc.createDocDialog.representativeHint' | transloco }}</span>
        </div>
        <div *ngIf="selectedRepresentative" class="company-card">
          <div class="company-icon">
            <mat-icon>handshake</mat-icon>
          </div>
          <div class="company-details">
            <div class="company-name">{{ selectedRepresentative.companyName }}</div>
            <div>
              {{ selectedRepresentative.address }},
              {{ selectedRepresentative.postCode }}
              {{ selectedRepresentative.city }},
              {{ selectedRepresentative.location }}
            </div>
          </div>
        </div>
      </ng-container>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onContinue()">
      {{ 'common.buttons.confirm' | transloco }}
    </button>
  </mat-dialog-actions>
</form>
